
<ng-container  *ngIf="pollFields && pollFields.length>0; else createFirst" >
    <ng-container *ngFor="let field of pollFields; let i=index">
        <div class="poll-block show" *ngIf="!(enableEdit && enableEditIndex == i); else edit" (click)="openEditForm(i, field)">
            <div class="drag-icon">
                <img src="assets/img/icons/drag.png" alt="">
            </div>
            <div *ngIf="field.schema.title; else defTitle" class="field-title">
                {{ field.schema.title }}
                <span *ngIf="field.schema.required">(Обязательный)</span>
            </div>
            <ng-template #defTitle> 
                <div class="field-title">
                    Заголовок
                    <span *ngIf="field.schema.required">(Обязательный)</span>
                </div>
            </ng-template>
            <div *ngIf="field.schema.description && field.schema.description.length>0" class="field-description">
                {{ field.schema.description }}
            </div>
            <ng-container *ngIf="field.schema.widget && field.schema.widget.id" [ngSwitch]="field.schema.widget.id">
                <div *ngSwitchCase="'string'">
                    <span class="string">Краткий ответ</span>
                </div>
                <div *ngSwitchCase="'textarea'">
                    <span class="string">Развернутый ответ</span>
                </div>
                <div *ngSwitchCase="'radio'">
                    <div  *ngFor="let item of field.schema.items.oneOf;">
                        <div class="radio-item disabled">
                            <div class="item">
                                <span class="choose">{{item.d}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngSwitchCase="'checkbox'">
                    <div  *ngFor="let item of field.schema.items.oneOf;">
                        <div class="checkbox-item disabled">
                            <div class="item">
                                <span class="choose">{{item.d}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <ng-template #edit>
            <!-- {{fieldForm.value | json}} -->
            <div class="poll-block edit" [formGroup]="fieldForm">
                <div formGroupName="schema">
                    <div class="drag-icon">
                        <img src="assets/img/icons/drag.png" alt="">
                    </div>
                    <div class="right-block">
                        <div class="right-icons-list">
                            <div class="right-icon createField" (click)="pushField(i)">
                                <mat-icon>add_circle_outline</mat-icon>
                            </div> 
                            <div class="right-icon createTitle">
                                <mat-icon>title</mat-icon>
                            </div>
                        </div>
                    </div>
                    <div class="poll-header">
                        <div class="poll-row">
                            <div class="poll-title">
                                <input type="text" placeholder="Заголовок" formControlName="title">
                            </div>
                            <div class="poll-widgets" formGroupName="widget">
                                <mat-select (selectionChange)="changeWidget(fieldForm.value.schema.widget.id)" formControlName="id" [ngClass]="fieldForm.value.schema.widget.id" panelClass="widgets-panel">
                                    <mat-option value="string" >
                                        <div class="option">
                                            <img src="assets/img/icons/string.png" alt="">
                                            <span>Текст (строка)</span>    
                                        </div>
                                    </mat-option>
                                    <mat-option value="textarea">
                                        <div class="option">
                                            <img src="assets/img/icons/textarea.png" alt="">
                                            <span>Текст (абзац)</span>    
                                        </div>
                                    </mat-option>
                                    <mat-divider class="option-divider"></mat-divider>
                                    <mat-option value="radio">
                                        <div class="option">
                                            <img src="assets/img/icons/radio.png" alt="">
                                            <span>Один из списка</span>    
                                        </div>
                                    </mat-option>
                                    <mat-option value="checkbox">
                                        <div class="option">
                                            <img src="assets/img/icons/checkbox.png" alt="">
                                            <span>Несколько из списка</span>    
                                        </div>
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div *ngIf="getDescription" class="poll-description">
                            <textarea cdkTextareaAutosize formControlName="description" placeholder="Описание"></textarea>
                        </div>
                    </div>
                    <div class="poll-main">
                        <ng-container *ngIf="fieldForm.value.schema.widget.id=='radio'">
                            <div class="radio-list" formGroupName="items"  cdkDropList (cdkDropListDropped)="drop($event)">
                                <ng-container *ngIf="FormOneOfData.controls.length>0">
                                    <div formArrayName="oneOf" *ngFor="let item of FormOneOfData.controls; let j = index" cdkDrag>
                                        <div formGroupName="{{j}}">
                                            <div class="radio-item">
                                                <div class="drag-item" cdkDragHandle>
                                                    <img src="assets/img/icons/drag.png" alt="">
                                                </div>
                                                <div class="item">
                                                    <input formControlName="d" value="">
                                                </div>
                                                <div class="item-delete" (click)="deleteCheckboxItem(j)">
                                                    <button mat-icon-button>
                                                        <mat-icon>delete_outline</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
            
                                <div class="add-radio" (click)="addCheckboxItem()">
                                    Добавить вариант
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="fieldForm.value.schema.widget.id=='checkbox'">
                            <div class="checkbox-list" formGroupName="items"  cdkDropList (cdkDropListDropped)="drop($event)">
                                <ng-container *ngIf="FormOneOfData.controls.length>0">
                                    <div formArrayName="oneOf" *ngFor="let item of FormOneOfData.controls; let j = index" cdkDrag>
                                        <div formGroupName="{{j}}">
                                            <div class="checkbox-item">
                                                <div class="drag-item" cdkDragHandle>
                                                    <img src="assets/img/icons/drag.png" alt="">
                                                </div>
                                                <div class="item">
                                                    <input formControlName="d" value="">
                                                </div>
                                                <div class="item-delete" (click)="deleteCheckboxItem(j)">
                                                    <button mat-icon-button>
                                                        <mat-icon>delete_outline</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
            
                                <div class="add-checkbox" (click)="addCheckboxItem()">
                                    Добавить вариант
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="fieldForm.value.schema.widget.id=='string'">
                            <input type="hidden">
                        </ng-container>
                    </div>
                    
                    <div class="bottom-block">
                        <div class="settings">
                            <div class="required">
                                <mat-slide-toggle [checked]="getRequired" (change)="ChangeRequired($event.checked)" labelPosition="before">Обязательный вопрос </mat-slide-toggle>
                            </div>
                            <div class="field-operation" >
                                <button mat-icon-button  (click)="copyField(i)">
                                    <mat-icon>filter_none</mat-icon>
                                </button>
                                <button mat-icon-button (click)="deleteField(i,field.id)">
                                    <mat-icon>delete_outline</mat-icon>
                                </button>
                            </div>
                            <div class="more">
                                <button mat-icon-button (click)="ShowMore()">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <div *ngIf="showMore" class="more-block">
                                    <div class="title">Показать</div>
                                    <mat-checkbox  [checked]="getDescription" (change)="ChangeShowDescription($event.checked)">Описание</mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="popup" *ngIf="showPopup" (click)="hideMore()"></div>
        </ng-template>
    </ng-container>
</ng-container>
<ng-template #createFirst>
    <div class="poll-block">
        <div class="poll-create">
            <div class="create-but" (click)="pushField(-1)">
                Создать первое поле
            </div>
        </div>
    </div>
</ng-template>

